var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenActiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "rgba(35, 40, 52, 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 30C28.6789 30 27 31.6789 27 33.75V36.25C27 36.9404 27.5596 37.5 28.25 37.5C28.9404 37.5 29.5 36.9404 29.5 36.25V33.75C29.5 33.0596 30.0596 32.5 30.75 32.5H48.25C48.9404 32.5 49.5 33.0596 49.5 33.75V46.25C49.5 46.9404 48.9404 47.5 48.25 47.5H40.75C40.0596 47.5 39.5 48.0596 39.5 48.75C39.5 49.4404 40.0596 50 40.75 50H48.25C50.3211 50 52 48.3211 52 46.25V33.75C52 31.6789 50.3211 30 48.25 30H30.75Z",
    fill: "rgba(255, 255, 255, 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 42.5C27.5596 42.5 27 43.0596 27 43.75C27 44.4404 27.5596 45 28.25 45C30.3211 45 32 46.6789 32 48.75C32 49.4404 32.5596 50 33.25 50C33.9404 50 34.5 49.4404 34.5 48.75C34.5 45.2983 31.7018 42.5 28.25 42.5Z",
    fill: "rgba(255, 255, 255, 1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40C27 39.3096 27.5596 38.75 28.25 38.75C33.7729 38.75 38.25 43.2271 38.25 48.75C38.25 49.4404 37.6904 50 37 50C36.3096 50 35.75 49.4404 35.75 48.75C35.75 44.6079 32.3921 41.25 28.25 41.25C27.5596 41.25 27 40.6904 27 40Z",
    fill: "rgba(255, 255, 255, 1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 50C28.9404 50 29.5 49.4404 29.5 48.75C29.5 48.0596 28.9404 47.5 28.25 47.5C27.5596 47.5 27 48.0596 27 48.75C27 49.4404 27.5596 50 28.25 50Z",
    fill: "rgba(255, 255, 255, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenActiveLight);
export default __webpack_public_path__ + "static/media/ShareScreenActiveLight.d8c3362868e6fe216590ff64a381dc67.svg";
export { ForwardRef as ReactComponent };